var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 91,
    viewBox: "0 0 98 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.3094 1L54.7499 28.8651L61.7254 12.4253L92.3094 1Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69067 1L42.9085 29.1288L36.2746 12.4253L5.69067 1Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8077 65.5963L68.8161 80.9068L90.1959 86.7866L96.306 65.9343L78.8077 65.5963Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73116 65.9343L7.80412 86.7866L29.1839 80.9068L19.2295 65.5963L1.73116 65.9343Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0139 39.7258L22.0561 48.7405L43.2502 49.684L42.5333 26.8667L28.0139 39.7258Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9861 39.7258L55.2401 26.603L54.7499 49.684L75.9439 48.7406L69.9861 39.7258Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1839 80.9068L41.9687 74.6816L30.9557 66.0865L29.1839 80.9068Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0313 74.6816L68.8161 80.9068L67.0444 66.0865L56.0313 74.6816Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8161 80.9068L56.0313 74.6816L57.049 83.0166L56.9376 86.5229L68.8161 80.9068Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1839 80.9068L41.0624 86.5229L40.9881 83.0166L41.9687 74.6816L29.1839 80.9068Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.289 60.5782L30.6548 57.4507L38.1578 54.0186L41.289 60.5782Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.711 60.5782L59.8422 54.0186L67.3824 57.4507L56.711 60.5782Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1839 80.9068L31.03 65.5963L19.2295 65.9343L29.1839 80.9068Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.97 65.5963L68.8161 80.9068L78.8077 65.9343L66.97 65.5963Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9439 48.7405L54.7499 49.684L56.711 60.5782L59.8422 54.0186L67.3824 57.4507L75.9439 48.7405Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6548 57.4507L38.1578 54.0186L41.289 60.5782L43.2502 49.684L22.0561 48.7405L30.6548 57.4507Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0561 48.7405L30.9557 66.0866L30.6548 57.4507L22.0561 48.7405Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3823 57.4507L67.0443 66.0866L75.9439 48.7405L67.3823 57.4507Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2502 49.684L41.289 60.5782L43.7776 73.4373L44.3051 56.5072L43.2502 49.684Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7498 49.684L53.7321 56.4701L54.2224 73.4373L56.711 60.5782L54.7498 49.684Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.711 60.5782L54.2224 73.4372L56.0313 74.6816L67.0443 66.0865L67.3823 57.4507L56.711 60.5782Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6548 57.4507L30.9557 66.0865L41.9687 74.6816L43.7776 73.4372L41.289 60.5782L30.6548 57.4507Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9376 86.5229L57.049 83.0165L56.1093 82.1883H41.8907L40.9881 83.0165L41.0624 86.5229L29.1839 80.9068L33.3329 84.298L41.7793 90.1444H56.2207L64.6671 84.298L68.8161 80.9068L56.9376 86.5229Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0313 74.6816L54.2224 73.4373H43.7776L41.9687 74.6816L40.9882 83.0166L41.8907 82.1883H56.1093L57.049 83.0166L56.0313 74.6816Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8917 30.6777L97.06 15.2928L92.3094 1L56.0313 27.9253L69.9861 39.7258L89.7056 45.4979L94.044 40.4055L92.1571 39.0498L95.1731 36.2938L92.8739 34.4849L95.89 32.1857L93.8917 30.6777Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0.940002 15.2928L4.14549 30.6777L2.11003 32.1857L5.12608 34.4849L2.82689 36.2938L5.84295 39.0498L3.95606 40.4055L8.29442 45.4979L28.0139 39.7258L41.9687 27.9253L5.69066 1L0.940002 15.2928Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7056 45.4979L69.9861 39.7258L75.9439 48.7406L67.0443 66.0866L78.8077 65.9343H96.306L89.7056 45.4979Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0139 39.7258L8.29442 45.4979L1.73116 65.9343H19.2295L30.9557 66.0866L22.0561 48.7406L28.0139 39.7258Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7498 49.684L56.0313 27.9253L61.7254 12.4254H36.2746L41.9687 27.9253L43.2502 49.684L43.7405 56.5444L43.7776 73.4373H54.2224L54.2595 56.5444L54.7498 49.684Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.712817,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.2b0c1aabc7f5289a4f6e08c60f270c4e.svg";
export { ForwardRef as ReactComponent };